/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class DatasetService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProductsCsv
   */
  static readonly GetProductsCsvPath = '/products';

  /**
   * Get all products.
   *
   * Download all products dataset
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsCsv$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DatasetService.GetProductsCsvPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get all products.
   *
   * Download all products dataset
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductsCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsCsv(params?: {
  }): Observable<Blob> {

    return this.getProductsCsv$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getCategoryCsv
   */
  static readonly GetCategoryCsvPath = '/categories';

  /**
   * Get all categories.
   *
   * Download all categories dataset
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategoryCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryCsv$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DatasetService.GetCategoryCsvPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get all categories.
   *
   * Download all categories dataset
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCategoryCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryCsv(params?: {
  }): Observable<Blob> {

    return this.getCategoryCsv$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
